import {
  CommonHelperFunctions,
  ICRUDGetGalleryViewDiRequest,
  ICRUDGetTableDiRequest,
  ICRUDRequest,
  ICRUDResponse,
  IDisplayItem
} from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";
import { UserService } from "./user-service";

export class CrudService {
  static backendUrl: string = CommonHelperFunctions.GetBackendUrl();

  public static async createCRUD(crudRequest: ICRUDRequest): Promise<AxiosResponse<ICRUDResponse>> {
    try {
      const res = await Axios.post<ICRUDRequest, AxiosResponse<ICRUDResponse>>(
        `${CrudService.backendUrl}/crud/createCRUD`,
        crudRequest
      );
      await UserService.GetUserInfoForce();
      return res;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetGalleryViewDi(request: ICRUDGetGalleryViewDiRequest): Promise<AxiosResponse<IDisplayItem>> {
    try {
      return await Axios.post<ICRUDGetGalleryViewDiRequest, AxiosResponse<IDisplayItem>>(
        `${CrudService.backendUrl}/crud/getgalleryviewdi`,
        request
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetTableDi(request: ICRUDGetTableDiRequest): Promise<AxiosResponse<IDisplayItem>> {
    try {
      return await Axios.post<ICRUDGetTableDiRequest, AxiosResponse<IDisplayItem>>(
        `${CrudService.backendUrl}/crud/gettabledi`,
        request
      );
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
